export enum MonitorQueryKeys {
  ErrorsPaginated = "monitor.errors.paginated",
  ErrorDetail = "monitor.errors.detail",
  SocketHealth = "monitor.socketHealth",
  LoginSecurity = "monitor.loginSecurity",
}
